<template>
    <div class="overdue-requests-chart">
        <div class="chart-container">
            <div class="chart-header">
                <h5>
                    <i class="fal fa-exclamation-triangle text-danger"></i>
                    Solicitudes Vencidas por Tema
                </h5>
            </div>

            <div v-if="sortedOverdue.length === 0" class="empty-state">
                Sin datos disponibles
            </div>

            <div v-else class="bars-list">
                <div
                    v-for="item in sortedOverdue"
                    :key="item.nombre"
                    class="bar-row"
                >
                    <div class="bar-label" :title="item.nombre">
                        {{ item.nombre }}
                    </div>
                    <div class="bar-track">
                        <div
                            class="bar-fill"
                            :style="{
                                width: pct(item.vencidas, maxValue) + '%',
                            }"
                        ></div>
                    </div>
                    <div class="bar-total">{{ item.vencidas }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OverdueRequestsChart",
    props: {
        overdueData: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        sortedOverdue() {
            return [...this.overdueData]
                .map((item) => ({
                    nombre: item.nombre || "Sin tema",
                    vencidas: Number(item.vencidas || 0),
                }))
                .sort((a, b) => b.vencidas - a.vencidas);
        },
        maxValue() {
            const values = this.sortedOverdue.map((item) => item.vencidas);
            return Math.max(1, ...values);
        },
    },
    methods: {
        pct(value, max) {
            if (!max) return 0;
            return (value / max) * 100;
        },
    },
};
</script>

<style scoped>
.overdue-requests-chart {
    margin-bottom: 20px;
}

.chart-container {
    background: #ffffff;
    border-radius: 14px;
    padding: 22px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 20px;
}

.chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;
}

.chart-header h5 {
    color: #1f2937;
    font-weight: 600;
    margin: 0;
}

.bars-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.bar-row {
    display: grid;
    grid-template-columns: 180px 1fr 36px;
    align-items: center;
    gap: 14px;
}

.bar-label {
    font-size: 0.88rem;
    color: #374151;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.bar-track {
    height: 14px;
    background: #f3f4f6;
    border-radius: 999px;
    overflow: hidden;
}

.bar-fill {
    height: 100%;
    border-radius: 999px;
    background: #ef4444;
    transition: width 0.4s ease;
}

.bar-total {
    text-align: right;
    font-weight: 700;
    color: #111827;
    font-size: 0.92rem;
}

.empty-state {
    text-align: center;
    color: #9ca3af;
    padding: 40px 0;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .chart-container {
        padding: 18px;
    }
    .bar-row {
        grid-template-columns: 120px 1fr 30px;
        gap: 10px;
    }
    .bar-label {
        font-size: 0.78rem;
    }
}
</style>
